(() => {
    console.log('%c👍🏼 Cookie Consent', 'color: yellow');
    const syncToZaraz = () => {
        if (!window.zaraz || !window.zaraz.consent || !window.Cookiebot) {
            return;
        }

        const consentPreferences = {
            KOWY: Cookiebot.consent.marketing,
            hCAT: Cookiebot.consent.statistics,
            hWbr: Cookiebot.consent.preferences
        };

        window.zaraz.set("google_consent_update",  {
            'ad_storage': Cookiebot.consent.marketing ? 'granted' : 'denied',
            'ad_user_data': Cookiebot.consent.marketing ? 'granted' : 'denied',
            'ad_personalization': Cookiebot.consent.marketing ? 'granted' : 'denied',
            'analytics_storage': Cookiebot.consent.statistics ? 'granted' : 'denied'
        });

        // doesn't work when set all at once

        // statistics
        window.zaraz.consent.set({hCAT: consentPreferences.hCAT});

        // preferences
        //window.zaraz.consent.set({hWbr: consentPreferences.hWbr});

        // marketing
        window.zaraz.consent.set({KOWY: consentPreferences.KOWY});
        window.zaraz.consent.sendQueuedEvents();
    };

    window.addEventListener('CookiebotOnConsentReady', function () {
        if (!window.Cookiebot) {
            return;
        }

        if (Cookiebot.consent.statistics) {
            loadClarity();
        }

        if (!window.zaraz || !window.Cookiebot) {
            return;
        }

        syncToZaraz();
    });

    const loadClarity = () => {
        if (!window.clarity) {
            (function(c,l,a,r,i,t,y){
                c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
                t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
                y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
            })(window, document, "clarity", "script", 'igl5u9pw7c');
        }
    };

    // disable modal as we'll be using Cookiebot's
    document.addEventListener("zarazConsentAPIReady", () => {
        if (window.zaraz.consent.modal) {
            window.zaraz.consent.modal = false;
        }
        syncToZaraz();
    });
})();